/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface POIUpdate { 
    Name?: string | null;
    Id: string;
    Width?: number | null;
    Height?: number | null;
    X?: number | null;
    Y?: number | null;
}

